import { useEffect, useState } from "react";
import { Minus, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function CounterMilestone({ item, record, canEdit, busy, onAct, testid }) {
  const count = record?.count || 0;
  const [draft, setDraft] = useState(String(count));
  const [confirmDec, setConfirmDec] = useState(false);
  useEffect(() => { setDraft(String(count)); }, [count]);
  const n = /^\d{1,3}$/.test(draft) ? Number(draft) : null;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-3 sm:p-4" data-testid={testid}>
      <div className="text-sm font-medium text-slate-900">{item.title}</div>
      <div className="text-[11px] text-slate-500 mt-0.5">Total number of 90-day core runs you've completed. No dates needed.</div>
      <div className="flex flex-wrap items-center gap-3 mt-3">
        <Button size="icon" variant="outline" className="h-11 w-11" disabled={!canEdit || busy || count === 0}
                onClick={() => setConfirmDec(true)} aria-label="Remove one" data-testid={`${testid}-dec`}><Minus className="w-4 h-4" /></Button>
        <span className="font-serif text-3xl text-[#0A1F44] min-w-[2ch] text-center" data-testid={`${testid}-count`}>{count}</span>
        <Button size="icon" variant="outline" className="h-11 w-11" disabled={!canEdit || busy}
                onClick={() => onAct({ action: "adjust", delta: 1 })} aria-label="Add one" data-testid={`${testid}-inc`}><Plus className="w-4 h-4" /></Button>
        {canEdit && (
          <div className="flex items-center gap-2">
            <Input inputMode="numeric" value={draft} onChange={(e) => setDraft(e.target.value.trim())} className="h-11 w-20" aria-label="Total completed" data-testid={`${testid}-input`} />
            <Button variant="ghost" className="h-11" disabled={busy || n === null || n === count}
                    onClick={() => onAct({ action: "set_count", count: n })} data-testid={`${testid}-set`}>Set total</Button>
          </div>
        )}
      </div>
      {canEdit && draft && n === null && <div className="text-xs text-red-700 mt-1">Enter a whole number from 0 to 999.</div>}
      <AlertDialog open={confirmDec} onOpenChange={setConfirmDec}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Remove one completed core run?</AlertDialogTitle>
            <AlertDialogDescription>Your total will go from {count} to {count - 1}.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction className="bg-[#0A1F44]" data-testid={`${testid}-dec-confirm`}
                               onClick={() => { onAct({ action: "adjust", delta: -1 }); setConfirmDec(false); }}>Remove one</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
